import { Injectable } from '@angular/core';
import { SolrService } from '../solr/solr.service';
import { EmpresaService } from './empresa.service';
import { Empresa } from '../_models/empresa';

@Injectable({
  providedIn: 'root'
})
export class NestedMetadataService {
nestedMetadataObject: any;
    constructor(
    private solrService: SolrService,
    private empresaService: EmpresaService
    ) {

    }


    getFields(
        core: string, 
        empresaId: string, 
        prefix: string){
        return new Promise((resolve, reject) =>{
            const keyNested = prefix;
            this.empresaService.getById(empresaId).subscribe((emp: Empresa) =>{
                this.solrService.getSchemaSolrFields(core).subscribe((fields: any) => {
                    this.nestedMetadataObject = emp.nestedMetadata || [];
                    for (const field of fields['fields']){
                        const key = field.name
                        if ((key.indexOf(prefix+'_')!==-1) && 
                        (this.nestedMetadataObject.length == 0 || (this.nestedMetadataObject.length > 0 && this.nestedMetadataObject.filter((metadata:any) => metadata.solrName==key).length == 0))){
                            let obj:any = {ativo:true, filtro:false, nome: key.replace(keyNested+"_", ''), solrName:key, field: key, solrCore:"docs-ia", tipo:"Texto", order: -1};
                            this.nestedMetadataObject.push(obj);
                        }
                    }
                    this.empresaService.updateByFields(empresaId, this.nestedMetadataObject).subscribe(resp =>{
                        resolve(this.nestedMetadataObject);
                    })
                },(err =>{
                    reject(err);
                }));
            })
        })
        
        
    }

}
